import { ROUTES_MAP } from 'app/shared/utils/routes';

export enum ReportType {
  FINTRAC_STR = 'FINTRAC_STR',
  FINCEN_SAR = 'FINCEN_SAR',
  GOAML_STR = 'GOAML_STR',
  FINCEN_CTR = 'FINCEN_CTR',
  FINCEN_DOEP = 'FINCEN_DOEP',
  /**
   * @deprecated Kept for legacy filings
   */
  ESTONIAN_FIU = 'ESTONIAN_FIU',
  /**
   * @deprecated Kept for legacy filings
   */
  NCA_SAR = 'NCA_SAR',
}

export const REPORT_TYPE_PATH_MAP: Record<ReportType, string> = {
  [ReportType.FINTRAC_STR]: ROUTES_MAP.filingsFintracStrId.path,
  [ReportType.FINCEN_SAR]: ROUTES_MAP.filingsSarId.path,
  [ReportType.GOAML_STR]: ROUTES_MAP.filingsGoAMLIdEdit.path,
  [ReportType.FINCEN_CTR]: ROUTES_MAP.filingsFincenCtrEdit.path.replace(
    '/:tab?',
    '',
  ),
  [ReportType.FINCEN_DOEP]: ROUTES_MAP.filingsFincenDoepId.path.replace(
    '/:tab?',
    '',
  ),
  [ReportType.ESTONIAN_FIU]: ROUTES_MAP.fourOhFour.path, // deprecated
  [ReportType.NCA_SAR]: ROUTES_MAP.fourOhFour.path, // deprecated
};

export const REPORT_TYPE_DISPLAY_TEXT_MAP: Record<ReportType, string> = {
  [ReportType.FINTRAC_STR]: 'FINTRAC STR',
  [ReportType.FINCEN_SAR]: 'FinCEN SAR',
  [ReportType.GOAML_STR]: 'goAML STR',
  [ReportType.FINCEN_CTR]: 'FinCEN CTR',
  [ReportType.FINCEN_DOEP]: 'FinCEN DOEP',
  [ReportType.ESTONIAN_FIU]: 'Unsupported', // deprecated
  [ReportType.NCA_SAR]: 'Unsupported', // deprecated
};
